import { useFormik } from 'formik';
import { setCreateAccountInformation } from 'pages/Create-account/store/actions/create-account.types';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router';
import { getCountryForPlan } from 'shared/services/plans';
import { setStateError } from 'store/actions/app.types';
import { setBranch } from 'store/actions/branch.types';
import * as utils from 'utils/branch.utils';
import { IFormAuth, IFormAuthErrors } from '../models/Auth.interface';
import * as _authService from '../services/Auth.service';

export const UseAuthValidation = () => {
  const [recaptcha, setRecaptchaInternal] = useState<any | null>(null);
  const isMounted = useRef(true);
  const { planId } = useParams();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { search } = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(search);
  const emailParams = params.get('email') as string;

  useEffect(() => {
    return () => {
      isMounted.current = false; // marca como desmontado cuando el componente se destruye
    };
  }, []);

  const safeSetIsLoading = (value: boolean) => {
    if (isMounted.current) {
      setIsLoading(value);
    }
  };

  const setRecaptcha = (ref: unknown) => {
    if (isMounted.current) {
      setRecaptchaInternal(ref);
    }
  };

  const formAuthInitialValues: IFormAuth = {
    email: emailParams ?? '',
  };

  const formLoginValidate = (values: IFormAuth) => {
    const errors: IFormAuthErrors = {};
    if (!values.email) {
      errors.email = 'Este campo es requerido';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = 'No es un correo valido, debe tener @ y dominio';
    }
    return errors;
  };

  const validateEmail = async (email: string, authorizationToken: string) => {
    const response = await _authService.validateEmail(
      email,
      authorizationToken
    );

    if (!isMounted.current) return response;

    if (response.userCreated) {
      navigate('/login', { state: { email } });
    } else {
      if (planId) {
        const country = await getCountryForPlan(Number(planId.split(',')[0]));
        dispatch(
          setCreateAccountInformation({
            plan_id: planId,
            country_id: country.id as string,
            indicator: utils.getPhoneIndicator(country.acronym),
          })
        );
        dispatch(setBranch(country.acronym));
      }
      navigate('/create-account', { state: { email } });
    }
    return response;
  };

  const validateCaptcha = async () => {
    await recaptcha.execute();
    return recaptcha.getResponse();
  };

  const formAuth = useFormik({
    initialValues: formAuthInitialValues,
    validate: formLoginValidate,
    onSubmit: async (values) => {
      try {
        safeSetIsLoading(true);
        const authorizationToken = await validateCaptcha();
        await validateEmail(values.email, authorizationToken);
      } catch (error) {
        if (isMounted.current) {
          dispatch(setStateError(true));
        }
      } finally {
        safeSetIsLoading(false);
      }
    },
  });

  return {
    isLoading,
    formAuth,
    setRecaptcha,
    planId,
  };
};
